// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ProcessTag } from "./ProcessTag";
import {
  ProcessTagFromJSON,
  ProcessTagFromJSONTyped,
  ProcessTagToJSON,
  ProcessTagToJSONTyped,
} from "./ProcessTag";

/**
 *
 * @export
 * @interface TagsInner
 */
export interface TagsInner {}

/**
 * Check if a given object implements the TagsInner interface.
 */
export function instanceOfTagsInner(value: object): value is TagsInner {
  return true;
}

export function TagsInnerFromJSON(json: any): TagsInner {
  return TagsInnerFromJSONTyped(json, false);
}

export function TagsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagsInner {
  return json;
}

export function TagsInnerToJSON(json: any): TagsInner {
  return TagsInnerToJSONTyped(json, false);
}

export function TagsInnerToJSONTyped(
  value?: TagsInner | null,
  ignoreDiscriminator: boolean = false
): any {
  return value;
}
